module.exports = __webpack_public_path__ + "img/13d@2x.67d63a14.svg";